export const IDO_PRINT_LIST_VIEW_MODE_LARGE = 'IDO_PRINT_LIST_VIEW_MODE_LARGE';
